/**
 * Fetch dynamic ICE servers from the backend, with a sane local fallback.
 * Cached for the page session so the call setup is instant after the first
 * fetch.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_ICE = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
  { urls: 'stun:stun.cloudflare.com:3478' },
  // free public TURN — last-resort, may be rate-limited
  {
    urls: [
      'turn:relay1.expressturn.com:3478?transport=udp',
      'turn:relay1.expressturn.com:3478?transport=tcp',
    ],
    username: 'ef9TZRG8C5WG2C5W2P',
    credential: 'wHHsZIBlQ6qkdvE5',
  },
];

let cached = null;
let inflight = null;

export async function getIceServers() {
  if (cached) return cached;
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const token = localStorage.getItem('fityh_token');
      const r = await axios.get(`${API}/webrtc/ice-servers`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: 4000,
      });
      if (r.data?.iceServers?.length) {
        cached = r.data.iceServers;
        return cached;
      }
    } catch {}
    cached = FALLBACK_ICE;
    return cached;
  })();
  const res = await inflight;
  inflight = null;
  return res;
}

export function clearIceCache() {
  cached = null;
}
